import { render, staticRenderFns } from "./RestriccionPostulante.vue?vue&type=template&id=3127a7cc&scoped=true&"
import script from "./RestriccionPostulante.vue?vue&type=script&lang=js&"
export * from "./RestriccionPostulante.vue?vue&type=script&lang=js&"
import style0 from "./RestriccionPostulante.vue?vue&type=style&index=0&id=3127a7cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3127a7cc",
  null
  
)

export default component.exports